<template>
    <div>
    <b-modal id="modal-facebook" title="Add Facebook Content" hide-footer size="lg" centered @hidden="resetForm">
        <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(validateAndSubmit2)">
            <b-row>
                <b-col md="6">
                    <b-form-group label="Post Name" label-for="campaign_name">
                        <validation-provider rules="required" #default="{ errors }" name="post name">
                            <b-form-input v-model="campaignName" :state="errors.length > 0 ? false : null"
                                @blur="validateCampaignName" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Budget" label-for="budget">
                        <validation-provider rules="required|numeric|min_value:1" #default="{ errors }" name="cost">
                            <b-form-input type="number" v-model="cost" placeholder="Enter Budget"
                                :state="errors.length > 0 ? false : null" @blur="validateCost" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Email Template -->
                <b-col md="12">
                    <b-form-group label="Template" label-for="email_template">
                        <validation-provider #default="{ errors }" name="email template" vid="Email Template">
                            <b-form-select 
                                v-model="selectedTemplateId"
                                :options="templateOptions"
                                @change="selectTemplate"
                                :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                

                <!-- Subject -->
                <!-- <b-col md="12">
                    <b-form-group label="Subject" label-for="subject">
                        <validation-provider #default="{ errors }" name="subject" vid="Subject">
                            <b-form-input v-model="selectedTemplate.subject" placeholder="Subject" name="subject"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col> -->


                <!-- Email Content -->
                <b-col md="12">
                    <b-form-group label="Content" label-for="email_content">
                        <validation-provider rules="required" #default="{ errors }" name="Content"
                            vid="Email Content">
                            <quill-editor v-model="selectedTemplate.content" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-col md="12">
                <b-form-group label="Upload Media (Accepted file types: Images (JPG, PNG, GIF,webp), Videos (MP4, AVI). Max size: 5MB per file. Max 2 files.)" label-for="upload_media">
                    <validation-provider  #default="{ errors }" name="upload media">
                    <b-form-file v-model="files" @change="convertFilesToBase64" multiple 
                        placeholder="Choose up to 2 files..." accept="image/*,video/*" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <!-- Uploaded Media Section -->
<b-col v-if="base64Files.length" cols="12">
    <h5>Uploaded Media:</h5>
    <b-row>
        <b-col v-for="(media, index) in uploadedMedia" :key="'uploaded-' + index" cols="3" class="mb-2">
            <b-card class="preview-card">
                <!-- Image Preview -->
                <b-img 
                    v-if="media.type === 'photos'"
                    :src="media.src" 
                    class="preview-media"
                    alt="Uploaded Image"
                />

                <!-- Video Preview -->
                <video 
                    v-else-if="media.type === 'videos'"
                    class="preview-media"
                    controls
                >
                    <source :src="media.src" type="video/webm" />
                    Your browser does not support the video tag.
                </video>

                <p class="text-center mt-1 text-truncate">{{ media.name }}</p>
                <b-button variant="danger" size="sm" class="mt-1 w-100" @click="removeUploadedImage(index)">
                    Remove
                </b-button>
                <b-button variant="success" size="sm" class="mt-1 w-100" @click="previewImageSelected(media.src)">
                    Preview
                </b-button>
            </b-card>
        </b-col>
    </b-row>
</b-col>

            <b-col v-if="selectedTemplateId" cols="12" class="mb-2">            
                    <h5>Media Files:</h5>
                    <b-row>
                        <b-col v-for="(media, index) in previewMedia" :key="index" cols="3" class="mb-2">
                            <b-card class="preview-card">
                                <!-- Image Preview -->
                                <b-img 
                                    v-if="media.type === 'photos'"
                                    :src="media.src" 
                                    class="preview-media"
                                    alt="Preview Image"
                                />
            
                                <!-- Video Preview -->
                                <video 
                                    v-else-if="media.type === 'videos'"
                                    class="preview-media"
                                    controls
                                >
                                    <source :src="media.src" type="video/webm" />
                                    Your browser does not support the video tag.
                                </video>

                                <b-button variant="success" size="sm" class="mt-1 w-100" @click="previewImageSelected(media.src)">
                                    Preview
                                </b-button>
                            </b-card>
                        </b-col>
                    </b-row>
            </b-col>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Select Schedule Date" label-for="schedule_date">
                <b-form-datepicker 
                    v-model="scheduleDate" 
                    id="schedule_date" 
                    placeholder="Choose a date" 
                    locale="en"
                    :state="scheduleDate ? true : null" 
                    :min="today" 
                    :max="maxScheduleDate"
        @input="validateScheduleDate"/>
                    
            </b-form-group>
        </b-col>
    
        <b-col md="6">
            <b-form-group label="Select Schedule Time" label-for="schedule_time">
                <b-form-timepicker 
                    v-model="scheduleTime" 
                    id="schedule_time" 
                    placeholder="Choose a time" 
                    locale="en"
                    :state="scheduleTime ? true : null" 
                    @input="validateScheduleTime"/>
            </b-form-group>
      
    </b-col>
    
    
            </b-row>
            
            <b-col md="12" class="d-flex justify-content-end">
                <b-button type="submit"   variant="primary">{{ isEdit ? 'Update' : 'Save' }}</b-button>
            </b-col>
        </b-form>
    </validation-observer>
    </b-modal>
             <!-- Full Image Preview Modal -->
             <b-modal v-model="showImageModal" hide-footer hide-header centered size="lg">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="ml-2">Image Preview</h5>
                    <b-button variant="danger" @click="showImageModal = false" class="mr-2">Close</b-button>
                </div>
                <b-img :src="selectedImage" class="full-image" />
            </b-modal>
</div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import { BModal, BForm, BFormGroup, BFormSelect, BFormInput, BFormDatepicker, BButton, BCol, BRow, BFormRadio, BFormFile, BImg, BCard, BFormTimepicker} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    components: {
        BFormFile,
        BModal,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormDatepicker,
        BFormTimepicker,
        BButton,
        BCol,
        BRow,
        ValidationProvider,
        ValidationObserver,
        VSelect,
        quillEditor,
        BFormRadio,
        BImg,
        BCard
    },
    data() {
        return {
            files: [],
            base64Files: [],
            platformName: "Facebook",
            isEdit: false,
            mediaType: "image",
            mediaOptions: ["video", "image"],
            campaignId: this.$route.params.id,
            links: "",
            campaignName: "",
            campaignOptions: [],
            content: "",
            cost: "",
            startDate: null,
            endDate: null,
            selectedTemplateId: null,
            emailtemplatelist: [],
            selectedProvider: null,
            smtp: [],
            selectedSegments: [],
            segmentOptions: [],
            selectedTemplate: {
                subject: "",
                content: ""
            },
            showImageModal: false, // Controls modal visibility
            selectedImage: "", // Holds the image source for preview
            SelectedRadio: "D",
            quillOptions: {
                theme: "snow", // Use 'snow' theme for basic styling
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"], // Formatting buttons
                        [{ list: "ordered" }, { list: "bullet" }], // List buttons
                        [{ align: [] }], // Alignment buttons
                        ["clean"], // Remove formatting button
                    ],
                },
            },
            content: "",
            cost: "",
            scheduleDate: null,
            validationErrors: {
                campaignName: null,
                cost: null,
                content: null,
                link: null,
                mediaType: null,
            },
        };
    },

    computed: {
        today() {
        const today = new Date();
        return today.toISOString().split("T")[0]; 
    },
    maxScheduleDate() {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 29);
        return maxDate.toISOString().split("T")[0]; 
    },
    scheduleDateTime() {
        if (this.scheduleDate && this.scheduleTime) {
            return `${this.scheduleDate} ${this.scheduleTime}`;
        }
        return null;
    },

        ...mapGetters("marketingModule", {
            appid: "appid",
            campaignId: "campaignId",
            posts: "drafts",
            eventsTaskslist: "eventtasks",
            loadingMarketing: "loading",
            marketingTemplate: "marketingTemplate",
        }),
        today() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const day = String(today.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        uploadedMedia() {
        return this.base64Files.map((file, index) => ({
            src: file.data,
            type: file.extension.match(/(png|jpe?g|gif|bmp|webp)/) ? "photos" : "videos",
            name: `Uploaded File ${index + 1}`
        }));
    },
        previewMedia() {
        return this.selectedTemplate.mediaDetails
            ? JSON.parse(this.selectedTemplate.mediaDetails).map(media => ({
                src: media.Url,
                type: media.MediaType === "photos" ? "photos" : "videos",
                //name: media.Path.split('/').pop()
            }))
            : [];
    },
    templateOptions() {
        return this.emailtemplatelist.length > 0 
            ? this.emailtemplatelist 
            : [{ value: 0, text: "NO TEMPLATE AVAILABLE", disabled: true }];
    }
    },

    methods: {
        ...mapActions("marketingModule", [
            "getAppIdAction",
            "getPostAction",
            "removePostAction", "postSocialAction",
            "postMarketingCampaignAction",
            "getMarketingCampaignByIDAction",
            "putMarketingCampaignAction",
            "getCampaignDraftListAction", "postCampaignDraftAction", "putCampaignDraftAction",
            "getEventTaskListAction", "postEventTaskAction", "putEventTaskAction", "getContentTemplateAction"
        ]),

        validateScheduleDate() {
        if (!this.scheduleDate) return false;

        const today = new Date();
        const selectedDate = new Date(this.scheduleDate);

        const maxAllowedDate = new Date();
        maxAllowedDate.setDate(today.getDate() + 30);

        if (selectedDate > maxAllowedDate) {
            this.$swal("Error", "Schedule date cannot exceed 30 days from today.", "error");
            this.scheduleDate = null; 
            return false;
        }

        return true;
    },

    validateScheduleTime() {
        if (!this.scheduleTime || !this.scheduleDate) return false;

        const today = new Date();
        const selectedDate = new Date(this.scheduleDate);
        const [hours, minutes] = this.scheduleTime.split(":").map(Number);
        const selectedTime = new Date(selectedDate.setHours(hours, minutes));

        // If today is selected, enforce 10-minute buffer
        if (
            selectedDate.toDateString() === today.toDateString() &&
            selectedTime < new Date(today.getTime() + 10 * 60000)
        ) {
            this.$swal("Error", "Schedule time must be at least 10 minutes from now.", "error");
            this.scheduleTime = null; // Reset invalid time
            this.$nextTick(() => {
            this.scheduleTime = "";
        });
            return false;
        }

        return true;
    },

        selectTemplate() {
      this.selectedTemplate = this.marketingTemplate.find(
        (template) => template.id === this.selectedTemplateId
      );
    },
    previewImageSelected(imageSrc) {
        this.selectedImage = imageSrc;
        this.showImageModal = true;
    },
    removeUploadedImage(index) {
        this.base64Files = [...this.base64Files.slice(0, index), ...this.base64Files.slice(index + 1)];
    },
        setFormData(item) {
            // Check if it's an edit operation
            this.isEdit = !!item.campaignContentsId;
            this.editItemId = item.campaignContentsId || null;

            // Parse mediaDetails safely
            let mediaDetails = [];
            try {
                mediaDetails = JSON.parse(item.mediaDetails || "[]");
            } catch (error) {
                console.error("Error parsing media details:", error);
            }

            this.campaignName = item.name || "";
            this.cost = item.budget || "";
            this.content = item.content || "";

            // Extract the first media URL if available
            this.link = mediaDetails.length > 0 ? mediaDetails[0].Url.replace(/["]/g, '') : "";

            this.mediaType = mediaDetails.length > 0 ? mediaDetails[0].MediaType : "image";

            // Convert the scheduledPublishedDate to a valid format for the date picker
            this.scheduleDate = new Date(item.scheduledPublishedDate);
        },
        stripHtmlTags(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        },
        convertFilesToBase64(event) {
            const files = event.target.files;

            if (files.length > 2) {
                this.$swal({
            title: "Upload Limit Exceeded",
            text: "You can upload a maximum of 2 files.",
            icon: "warning",
            confirmButtonText: "OK",
            customClass: {
                confirmButton: "btn btn-danger",
            },
        });
        event.target.value = ""; 
        return;
            } else {
                this.validationErrors.files = null;
            }

            this.base64Files = [];
            Array.from(files).forEach((file) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const fileType = file.type.startsWith("image/") ? "image" : "video";
                    this.base64Files.push({
                        extension: file.name.split('.').pop().toLowerCase(),
                        data: `data:${file.type};base64,${reader.result.split(',')[1]}`,
                    });
                };
                reader.readAsDataURL(file);
            });
        },
        getFileExtension(file) {
            return file ? file.name.split('.').pop().toLowerCase() : "";
        },

        validateAndSubmit2() {
            // if (this.validateScheduleDate() && this.validateScheduleTime()){
            if (this.selectedTemplate.content && this.campaignName && this.cost) {
                this.submitCampaignForm();
            } else {
                this.$swal("Error", "Please fill in all required fields.", "error");
            }
        // }else{
        //     this.$swal("Error", "Schedule time must be at least 10 minutes from now.", "error");
        // }
        },

    //     validateAndSubmit() {
    //     if (this.validateScheduleDate() && this.validateScheduleTime()) {
    //         this.submitCampaignForm();
    //     }
    // },

        async submitCampaignForm() {
            if (!this.selectedTemplate.content|| !this.campaignName || !this.cost ) {
                this.$swal("Error", "Please make sure to fill all required fields.", "error");
                return;
            }
            let loader = this.$swal({
                title: "Processing...",
                text: "Please wait while the draft is being added",
                onOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });

            // Convert HTML to plain text while preserving line breaks
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.selectedTemplate.content;
            
            // Replace <br> and </p> with newlines before stripping tags
            let htmlWithLineBreaks = tempDiv.innerHTML
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/<\/p>/gi, '\n\n')
                .replace(/<[^>]+>/g, '');
                
            // Clean up multiple newlines and trim
            let cleanedContent = htmlWithLineBreaks
                .replace(/\n\s*\n\s*\n/g, '\n\n')
                .trim();

            const isValidDate = this.scheduleDate instanceof Date && !isNaN(this.scheduleDate);
            const Status = isValidDate && String(this.scheduleDate)?.trim() !== "" ? "SCHEDULED" : "DRAFT";
            console.log("date:", this.scheduleDate);
            
            const payload = {
                campaignId: this.campaignId,
                name: this.campaignName,
                emailTemplate: this.emailTemplate,
                subject: this.selectedTemplate.subject,
                content: cleanedContent,
                //templateId: this.selectedTemplateId,
                budget: this.cost,
                status: Status,
                platform: "Facebook",
                scheduledPublishedDate: `${this.scheduleDate} ${this.scheduleTime}`,
                mediaDetails: this.previewMedia.map(media => ({
    Path: "", // Always empty as per request
    Url: media.src, // Media URL
    MediaType: media.type // Media Type (photos/videos)
})),

                files: this.base64Files,
            };


            console.log("payload facebook:", payload);
            try {
                if (this.isEdit && this.editItemId) {
                    // Update existing entry
                    payload.campaignContentsId = this.editItemId;
                    await this.putCampaignDraftAction(payload);
                    this.$swal("Success", "Draft updated successfully!", "success");
                } else {
                    // Add new entry
                    await this.postCampaignDraftAction(payload);
                    this.$swal("Success", "Draft added successfully!", "success");
                }

                this.$emit("content-updated");
                this.$bvModal.hide("modal-facebook");
            } catch (error) {
                console.error("Error processing request:", error);
                this.$swal("Error", "Failed to save draft. Please try again.", "error");
            }

        },
        validateCampaignName() {
            this.validationErrors.campaignName = this.campaignName.trim() !== "" ? null : "Post Name is required";
        },
        validateCost() {
            this.validationErrors.cost = this.cost > 0 ? null : "Cost must be greater than zero";
        },
        validateContent() {
            this.validationErrors.content = this.content.trim() !== "" ? null : "Content is required";
        },
        validateLink() {
            const urlPattern = /^(http|https):\/\/[^ "]+$/;
            this.validationErrors.link = urlPattern.test(this.link) ? null : "A valid URL is required";
        },
        validateMediaType() {
            this.validationErrors.mediaType = this.mediaType ? null : "Media Type is required";
        },
        validateAndSubmit() {
            this.validateCampaignName();
            this.validateCost();
            this.validateContent();
            this.validateLink();
            this.validateMediaType();

            const hasErrors = Object.values(this.validationErrors).some(error => error !== null);
            if (!hasErrors) {
                this.submitCampaignForm();
            } else {
                this.$swal({
                    title: "Validation Error",
                    text: "Please fill in all required fields.",
                    icon: "error",
                    confirmButtonText: "OK",
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                });
            }
        },
        resetForm() {
            this.campaignName = "";
            this.cost = "";
            this.selectedTemplate = {
            subject: "",
            content: ""
        };
            this.selectedTemplateId = null;
            this.link = "";
            this.mediaType = "image";
            this.scheduleDate = null;
            this.scheduleTime = null;
            this.base64Files = [];
            // Reset validation errors
            this.validationErrors = {
                campaignName: null,
                cost: null,
                content: null,
                link: null,
                mediaType: null,
            };

            this.isEdit = false;
        }
    },
    async mounted(){
      await this.getContentTemplateAction(this.platformName).then(() => {
        this.emailtemplatelist = this.marketingTemplate.map((template) => ({
          value: template.id,
          text: `${template.name}`,
        }));
      });
      console.log('response',await this.getContentTemplateAction(this.platformName));
    },
};
</script>

<style>
.item-selector-title {
    width: 100%;
}
.preview-container {
    margin-top: 20px;
}

/* Styling for preview cards */
.preview-card {
    text-align: center;
    padding: 12px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
}

.preview-card:hover {
    transform: translateY(-15px);
}

/* Improved preview media (images/videos) */
.preview-media {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 8px;
}


.preview-image {
    width: 100px; 
    height: 100px; 
    object-fit: cover;
    border-radius: 5px; 
}

.text-truncate {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.full-image {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    display: block;
    margin: auto;
}

</style>